module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("k1OLL"))).then(() => parcelRequire('d0iPb'));